import { SurfaceService } from './surface-service.js';

export class SurfacePageService extends SurfaceService {}
